import { Activities } from "../activities/activities";
import { StaffSales } from "../sales/staffSales";

export const MODULES = {
  activities: {
    Component: Activities,
    moduleName: "activities"
  },
  staffSales: {
    Component: StaffSales,
    moduleName: "staffSales"
  }
};
